import OrderAddPage from './order-add';

export default OrderAddPage;